import { AnyAction } from 'redux';
import { TgvActions } from '../tgvActions';
import { isNavigationToDashboard } from './groupFailureSaga';

export const isLeavingAngebot = (action: AnyAction): boolean =>
  action.type === TgvActions.TGV_ANGEBOT_CLOSED ||
  action.type === TgvActions.TGV_ZUM_ANGEBOT_CLICKED ||
  isNavigationToDashboard(action);
